// removed by extract-text-webpack-plugin
module.exports = {"selected-categories-container":"assign-categories-form__selected-categories-container___3-UjD","no-selection":"assign-categories-form__no-selection___2FWoa","no-selection--actions":"assign-categories-form__no-selection--actions___23rJ_","actions":"assign-categories-form__actions___2oNBc","selected-item-container":"assign-categories-form__selected-item-container___E9--q"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/forms/assign-categories-form.scss
// module id = 1325
// module chunks = 0